import { render, staticRenderFns } from "./printinvoice.vue?vue&type=template&id=2e7227ba&"
import script from "./printinvoice.vue?vue&type=script&lang=js&"
export * from "./printinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports